module.exports = __webpack_public_path__ + "static/media/MAMMA.51ae9244.jpeg";